export const ConfigData = [
  {
    id: "name",
    name: "Location",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "address",
    name: "Location Address",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "email",
    name: "Operator Email Address",
    isShow: true,
    width: "117px",
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details","Edit", "Delete"],
    permission: {
      ["View Details"]: {
        id: "View Details",
        permission: "gamifications.view_campaign_operator_list",
      },
      ["Edit"]: {
        id: "Edit",
        permission: "gamifications.create_campaign_operator",
      },      
      Delete: {
        id: "Delete",
        permission: "gamifications.delete_campaign_operator",
      },
    },
  },
];

export const DefaulSorting = {
  id: "name,email",
  name: "Name",
  isShow: true,
  width: "170px",
  filter: true,
  format: "string",
};

export const data = [
    {'name': 'test','address': 'ABC', 'email': 'twin@weeswares.com'}
];
